import React from 'react'
import VideoPlayer from '../Components/VideoPlayer'
function Test() {
  return (
    <div style={{ width: "300px" }} className="p-3">
      <h1>Testing Page</h1>
      <VideoPlayer
        source="https://www.w3schools.com/html/mov_bbb.mp4"
        width={"100%"}
        height={400}
      />
    </div>
  )
}

export default Test
